import React from "react"

import { Element, Text } from "legacy/components/shared/base"
import Grid from "legacy/components/shared/Grid"
import WideHeroImage from "./Image"
import { Maybe } from "types/Maybe"
import RichText from "legacy/components/shared/RichText"
import { useTheme } from "src/legacy/utils"
import { WideHeroType } from "types/shared-components"

interface OwnProps {
  data: Maybe<WideHeroType>
}

export type WideHeroProps = OwnProps

const WideHero: React.FC<WideHeroProps> = ({
  data,
}): React.ReactElement | null => {
  if (!data?.primary) return null

  const { background_color, eyebrow, headline, hero_image } = data.primary
  const { sizes } = useTheme()

  return (
    <Element>
      <WideHeroImage bgColor={background_color} data={hero_image} />
      <Grid maxWidth={sizes.maxWidth}>
        <Element
          mb={["35", "45"]}
          px={["20", "40"]}
          textAlign={["left", "center"]}
        >
          {eyebrow && (
            <Text as="p" mb={["20"]} variant="captionCaps">
              {eyebrow}
            </Text>
          )}
          {headline && <RichText render={headline.richText} />}
        </Element>
      </Grid>
    </Element>
  )
}

export default WideHero
